import type { TonUsdtInvoice } from "@/types/tonUsdtPayment";

export const TON_USDT_MIN_AMOUNT = "10.00";

export interface ManualTonUsdtPayment {
  network: "TON" | "TON Testnet";
  asset: "USDT";
  amountUsdt: string;
  receivingAddress: string;
  memo: string;
}

export const toManualTonUsdtPayment = (invoice: TonUsdtInvoice): ManualTonUsdtPayment => {
  if (
    invoice.asset !== "USDT" ||
    (invoice.network !== "ton-mainnet" && invoice.network !== "ton-testnet")
  ) {
    throw new Error("Инвойс не предназначен для оплаты USDT в сети TON");
  }

  return {
    network: invoice.network === "ton-testnet" ? "TON Testnet" : "TON",
    asset: "USDT",
    amountUsdt: invoice.amount_usdt,
    receivingAddress: invoice.receiving_address,
    memo: invoice.reference,
  };
};
